var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-btn",
            {
              attrs: { color: "primary", dark: "" },
              on: {
                click: function($event) {
                  _vm.dialog = true
                }
              }
            },
            [_vm._v("Add Agent")]
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.formTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "row",
                                  model: {
                                    value: _vm.valid,
                                    callback: function($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Name",
                                          rules: _vm.nameRules,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.editedItem.name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.name"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Save the name exactly as it appears in bookeo, so the system can match the new bookings coming in. Example:"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v("Viator "),
                                          _c("strong", [
                                            _vm._v("is different of")
                                          ]),
                                          _vm._v(" VIATOR")
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v("kkday "),
                                          _c("strong", [
                                            _vm._v("is different of")
                                          ]),
                                          _vm._v(" Kkday")
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c(
                                        "fieldset",
                                        { staticClass: "inline-form" },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Phone Number" },
                                            model: {
                                              value: _vm.editedItem.phone,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "phone",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.phone"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.emailRules,
                                              label: "E-mail"
                                            },
                                            model: {
                                              value: _vm.editedItem.email,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.email"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c(
                                        "fieldset",
                                        { staticClass: "inline-form" },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              label: "Prepaid Booking",
                                              value: 1
                                            },
                                            model: {
                                              value: _vm.editedItem.prepaid,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "prepaid",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.prepaid"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            staticClass: "short",
                                            attrs: {
                                              label: "Commission",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.editedItem.commission,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "commission",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.commission"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.agents,
          "items-per-page": 10
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.edit(item)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-pencil")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "", color: "red" },
                    on: {
                      click: function($event) {
                        return _vm.deleteAgent(item.id)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-delete-forever")
                    ])
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "item.prepaid",
            fn: function(ref) {
              var item = ref.item
              return [item.prepaid ? _c("span", [_vm._v("Yes")]) : _vm._e()]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }